import { Link } from 'react-router-dom';
import { isLocalStudyExperience } from './mode';
import { STUDY_DEMO_CASES, demoToolPath } from './exampleData';
/** The demo supplies a source link, not a separate editor or a different calculation. */
export function StudyWorkingExampleLink({ id }: { id: string }) {
  if (!isLocalStudyExperience()) return null;
  const item = STUDY_DEMO_CASES.find((example) => example.workingId === id);
  return item ? (
    <div className="mt-4 rounded-2xl border border-hairline bg-wash-sky p-4 text-sm text-ink">
      <p>Prepared fictional example. {item.inputLabel}</p>
      <p className="mt-2">
        Explore different numbers in the real tool, then record and save your own reasoning on this
        working page.
      </p>
      <Link className="btn-pill-secondary mt-3 inline-flex" to={demoToolPath(item)}>
        Open the interactive tool for this example
      </Link>
    </div>
  ) : null;
}
